'use client';

import { cn } from '@utils';

export function Container({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) {
	return (
		<div className={cn('max-w-8xl mx-auto w-full px-4 md:px-8 lg:px-12', className)} {...props} />
	);
}
